import React from "react";
import { Row, Column } from "react-foundation";

const FormHeader = ({ title, subtitle }) => {
    return (
        <Row className="page-title-row">
            <Column small={10} medium={8} large={6} centerOnSmall>
                <h2 className="page-title">{title || "\u00a0"}</h2>
                <p className="page-subtitle">{subtitle || "\u00a0"}</p>
            </Column>
        </Row>
    );
};

export default FormHeader;



// WEBPACK FOOTER //
// ./src/components/FormHeader.js